import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

import { ref } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'modernStatusChip',
  props: ["text", "bgColors", "value", "isDeletable"],
  emits: ["status-clicked", "delete-clicked"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emits = __emit

const isDeleteButtonShown = ref(false)

const onStatusClicked = (value) => {
    console.log("status-clicked", value)
    emits("status-clicked", value)
}

const onDeleteClicked = (value) => {
    emits("delete-clicked", value)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onDblclick: _cache[1] || (_cache[1] = ($event: any) => (isDeleteButtonShown.value = !isDeleteButtonShown.value)),
    onClick: _cache[2] || (_cache[2] = ($event: any) => (onStatusClicked(__props.value))),
    style: _normalizeStyle({ 'backgroundColor': __props.bgColors[__props.value]}),
    class: "chip-container whitespace-nowrap relative"
  }, [
    _createElementVNode("p", null, _toDisplayString(props.text), 1),
    (__props.isDeletable && isDeleteButtonShown.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (onDeleteClicked(__props.value))),
          class: "delete-button"
        }, " x "))
      : _createCommentVNode("", true)
  ], 36))
}
}

})